<div class="message">
  <div class="message-header">
    <div class="message-category" [innerHTML]="getLabelCategory(message.category)"></div>
    <div class="message-date" [innerHTML]="getLabelDate(message.createdAt)"></div>
  </div>
  <div class="message-content" [innerHTML]="getContent(message.content)"></div>
  <div *ngIf="message.attachments && message.attachments.length > 0" class="message-attachments">
    <div *ngFor="let attachment of message.attachments"
         (click)="previewAttachment(attachment)"
         class="message-attachment-wrapper">
      <img [src]="attachment.url" [alt]="attachment.name">
    </div>
  </div>
  <ng-container *ngIf="message.thread && message.thread.length > 0">
    <hr>
    <div class="message-thread" *ngFor="let thread of message.thread" [class.support]="thread.supportReply">
      <div class="message-thread-wrapper">
        <div class="message-thread-header">
          <div class="message-thread-by">{{thread.supportReply ? 'MonSuiviDiet' : 'Moi'}} :</div>
          <div class="message-thread-date" [innerHTML]="getLabelDate(thread.createdAt)"></div>
        </div>
        <div class="message-thread-content" [innerHTML]="getContent(thread.content)"></div>
        <div *ngIf="thread.attachments && thread.attachments.length > 0" class="message-thread-attachments">
          <div *ngFor="let attachment of thread.attachments"
               (click)="previewAttachment(attachment)"
               class="message-attachment-wrapper">
            <img [src]="attachment.url" [alt]="attachment.name">
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="!hasReplier" class="message-reply">
    <a class="message-reply-link" (click)="this.hasReplier = true">
      <div class="d-flex align-items-center">
        <div>{{canReply() ? 'Répondre' : 'Préciser'}}</div>
        <div class="ml5px"><i i-bs name="arrow-right-square"></i></div>
      </div>
    </a>
  </div>
  <ng-container *ngIf="hasReplier">
    <hr>
    <div class="message-thread">
      <div class="message-thread-wrapper replier">
        <div class="message-reply-text">
                <textarea
                  [(ngModel)]="content"
                  aria-describedby="content"
                  class="form-control"
                  id="message-textarea"
                  placeholder="Votre message..."
                  rows="3"
                  type="text"></textarea>
        </div>
        <input #fileInput hidden id="fileInput" type="file" [accept]="acceptedFiles"
               (change)="addAttachment($event)">
        <div class="message-reply-attachment">
          <div *ngIf="attachments && attachments.length > 0">
            <div class="attachment" *ngFor="let attachment of attachments">
              <ng-container *ngIf="attachment.status === 'init'">
                <div class="label-attachment">
                  <i i-bs [name]="'file-earmark'"></i><span>{{ attachment.name }}</span>
                </div>
                <div class="action-attachment" (click)="removeAttachment(attachment)">
                  <i i-bs [name]="'trash-fill'"></i>
                </div>
              </ng-container>
              <ng-container *ngIf="attachment.status === 'started'">
                <div class="progress-attachment">
                  <progressbar *ngIf="(attachment.progress | async) !== -1" [value]="(attachment.progress | async) ?? -1" [type]="attachment.error ? 'danger' : 'info'" [animate]="true">{{ (attachment.progress | async) | number: '1.0-0' }}%</progressbar>
                </div>
              </ng-container>
              <ng-container *ngIf="attachment.status === 'completed'">
                <div class="label-attachment">
                  <i i-bs [name]="'file-earmark'"></i><span>{{ attachment.name }} : 100%</span>
                </div>
              </ng-container>
            </div>
          </div>
          <a (click)="fileInput.click()">
            <i i-bs name="plus-square"></i><span>Attacher un fichier image</span>
          </a>
        </div>
        <div class="message-reply-action">
          <button (click)="closeReplier()"
                  class="btn btn-outline-primary btn-outline text-only"
                  type="button">Annuler
          </button>
          <button (click)="postReplier()" [disabled]="!enablePostReplier()"
                  class="btn btn-primary btn-gradient">
            {{canReply() ? 'Répondre' : 'Préciser'}}
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="!hasReplier" class="message-close">
    <a class="message-close-link" (click)="closeMessageHelp()">
      <div class="d-flex align-items-center justify-content-end">
        <div>Fermer la demande</div>
        <div class="ml5px"><i i-bs name="x-square"></i></div>
      </div>
    </a>
  </div>
</div>
